import styled      from "styled-components";
import imagemFundo from "../../assets/fundo-login.jpg";

export const FundoLogin = styled.div`
  background-image: url(${imagemFundo});
  background-repeat: no-repeat;
  background-size: cover;
  width: 80vw;
  height: 80vh;
  text-align: center;
  vertical-align: middle;
  margin: auto;
  margin-top: 5vh;
  padding:3vh;
  padding-top: 10vh;
`;